import type { RoofColorView } from "@slfinrtl/ui-bff-routes"
import { FormProvider } from "react-hook-form"
import { ErrorNotificationInline } from "src/context/errorHandler/ErrorNotificationInline"
import { withErrorHandler } from "src/context/errorHandler/withErrorHandler"
import { useCustomRoofColor } from "./useCustomRoofColor"
import { CustomRoofColor } from "./view/CustomRoofColor"
import { CustomRoofColorSkeleton } from "./view/CustomRoofColorSkeleton"

export interface CustomRoofColorContainerProps {
	currentRoofColor: RoofColorView | undefined
	inventoryId: string
	onRoofColorCreated: (roofColor: RoofColorView) => void
	showCatalogRoofColorContainer: () => void
}

export const CustomRoofColorContainer = withErrorHandler(
	({
		currentRoofColor,
		inventoryId,
		onRoofColorCreated,
		showCatalogRoofColorContainer,
	}: CustomRoofColorContainerProps) => {
		const { form, onSubmit, props } = useCustomRoofColor({
			currentRoofColor,
			inventoryId,
			onRoofColorCreated,
			showCatalogRoofColorContainer,
		})
		return (
			<>
				<ErrorNotificationInline />
				{props ? (
					<FormProvider {...form}>
						<form onSubmit={form.handleSubmit(onSubmit)} noValidate>
							<CustomRoofColor {...props} />
						</form>
					</FormProvider>
				) : (
					<CustomRoofColorSkeleton />
				)}
			</>
		)
	},
)
